document.addEventListener("DOMContentLoaded", function () {
    const swiperConfigs = [
        {
            selector: ".product-features__swiper",
            mobileView: 1.5,
            desktopView: 3
        },
        {
            selector: ".product-videos__swiper",
            mobileView: 1.5,
            desktopView: 4.7
        }
    ];

    swiperConfigs.forEach(({ selector, mobileView, desktopView }) => {
        const container = document.querySelector(selector);
        if (!container) return;

        new Swiper(container, {
            speed: 400,
            spaceBetween: 24,
            slidesPerView: desktopView,
            slidesPerGroup: 1,
            breakpoints: {
                768: {
                    spaceBetween: 8,
                    slidesPerView: mobileView,
                    slidesPerGroup: 1
                }
            }
        });
    });

    const cards = document.querySelectorAll(".product-video__card");
    if (cards) {
        cards.forEach((card) => {
        const overlay = card.querySelector(".product-video__overlay");
        const video = card.querySelector("video");

        function togglePlayback() {
            cards.forEach((otherCard) => {
            const otherVideo = otherCard.querySelector("video");
            const otherOverlay = otherCard.querySelector(".product-video__overlay");

            if (otherVideo !== video) {
                otherVideo.pause();
                otherOverlay.classList.remove("hidden");
            }
            });

            if (video.paused) {
                video.play();
                overlay.classList.add("hidden");
            } else {
                video.pause();
                overlay.classList.remove("hidden");
            }
        }

        overlay.addEventListener("click", togglePlayback);
        video.addEventListener("click", togglePlayback);

        video.addEventListener("pause", () => {
            overlay.classList.remove("hidden");
        });

        video.addEventListener("play", () => {
            overlay.classList.add("hidden");
        });

        video.addEventListener("ended", () => {
            overlay.classList.remove("hidden");
        });
        });
    }
});